module.exports = __webpack_public_path__ + "static/media/mobile_separator_04.126e17b5.webp";